<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup bb001000l customer
 * @created at      :   2023/03/02
 * @created by      :   ANS873 – baonx@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import { mapMutations } from 'vuex';
import repository from '@/utils/repository';
import messages, { MSG_TYPE, MSG_TITLE } from '@/utils/messages';
import helpers from '@/utils/helpers';
/**
 * Define component chat for popup ba001000l customer
 */
var SamplePopupSearch = {
    template: template,
    props: {
        onSelected: Function,
        initData: Object
    },
    created() {
        this.doSearch();
    },
    data() {
        return {
            search: '',
            resultSearch: [],
            date_report: ''
        };
    },
    computed: {
        initObject() {
            return this.initData;
        }
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        doSearch: function () {
            repository
                .get(`ba/ba001000i/data/daily-report`, {
                    params: {
                        search: this.initObject.keyNum
                    }
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        this.resultSearch = data.Data;
                    } else {
                        this.resultSearch = [];
                    }
                });
        },
        selectFirstRow() {
            if (
                this.resultSearch &&
                this.resultSearch.length > 0 &&
                this.onSelected
            ) {
                this.onSelected(this.resultSearch[0]);
            }
        },
        selectRow(item) {
            if (this.onSelected) {
                this.onSelected(item);
            }
        },
        doAddDate() {
            if (this.date_report == '') {
                this.showHeaderError(messages.E013);
                return;
            }
            repository
                .put(`ba/ba001000i/data/create-date-report`, {
                    params: {
                        keynum: this.initObject.keyNum,
                        adddate: this.date_report
                    }
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        this.date_report = '';
                        this.doSearch();
                    }
                });
        },
        doDeleteDate(index, date) {
            document
                .getElementById('ba001000l_mess')
                .classList.add('ba001000l_mess_del');
            setTimeout(() => {
                var mess_del =
                    document.getElementsByClassName('modal-backdrop')[1];
                mess_del.classList.add('ba001000l_modal_backdrop_del');
            }, 100);

            date = new Date(date).toYYYYMMDD();
            const vm = this;
            vm.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C003,
                content: messages.C003,
                cancelText: '<strong>いいえ</strong>',
                callback: (ok) => {
                    if (ok) {
                        repository
                            .delete(`ba/ba001000i/data/delete-date-report`, {
                                params: {
                                    keynum: vm.initObject.keyNum,
                                    deledate: date
                                }
                            })
                            .then((res) => {
                                const { data } = res;
                                if (data.Code === 200) {
                                    vm.resultSearch.splice(index, 1);
                                }
                            });
                    }
                }
            });
        },
        doCustomerDetail(item) {
            this.$router.push({
                name: 'Ba001000i',
                query: {
                    p: helpers.encodeParams({
                        page: this.initObject.page,
                        keyNum: this.initObject.keyNum,
                        workdate: item.workdate
                    })
                }
            });
        }
    }
};
export default SamplePopupSearch;
</script>
